import React, { useState, useEffect, useRef } from "react";
import "./SubscriberAnalytics.css"
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { } from "react-bootstrap-table2-paginator";
import {
    MdKeyboardDoubleArrowLeft,
    MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { FaPlay, FaPause, FaClock, FaEye, FaUsers, FaGlobe, FaMobileAlt, FaVideo, FaChartLine, FaCopy, FaCheck } from "react-icons/fa";
import './UsersRevenue.css'
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import axios from "axios";
import { finalRouteApi, adminApiHeader } from "../../../components/CommonApis/CommonApiUrl";
import ApexAreaChart from "./Chart/ApexAreaChart";
import { IconFilter } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { formatDate, formatDateTimeText } from "../../../components/CommonMethod/CommonMethods";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import useTablePage from "../../../components/CommonComponents/useTablePage";
import { CSVColumnSubscriber, PDFGeneratorSubscriber, XLSXGeneratorSubscriber } from "../../../components/CommonMethod/CommonMethods";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { CSVLink } from "react-csv";

const SubscriberAnalytics = () => {
    const userAccessToken = getItemToken('access_token');

    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [apiData, setApiData] = useState([]);
    const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
    const [total, setTotal] = useState('');
    const { fetchRequest } = useMyContext();
    const [formData, setFormData] = useState({
        state: "formData",
        view_type: "list",
        view_type_option: [{ name: "List", value: "list" }, { name: "Gallery", value: "grid" }]
    });
    const [withOutRefresh, setWithoutRefresh] = useState(false)
    const [copiedId, setCopiedId] = useState(null);
    const [loading, setLoading] = useState(false);

    // Filters
    const [editUser, setEditUser] = useState({
        startDate: "",
        endDate: "",
        filterType: "",
        platform: "All",
        country: "All",
        status: "All",
        topVideoFilter: "currentMonthData"
    });

    const [defaultData, setDefaultData] = useState({
        filterTypes: [],
        countries: ["Australia", "India", "USA", "UK", "Canada"],
        platforms: ["Web", "iOS", "Android"],
        statusOptions: ["Subscribed", "Non-Subscribed"]
    });

    const [subscriptionCounts, setSubscriptionCounts] = useState({
        total: 0,
        active: 0,
        cancelled: 0
    });

    const [chartData, setChartData] = useState({
        categories: [],
        series: [{ name: "SUBSCRIBER", data: [] }]
    });

    const [topVideosData, setTopVideosData] = useState({});
    const [topVideos, setTopVideos] = useState([]);

    const startDateRef = useRef()
    const endDateRef = useRef()
    const filterTypeRef = useRef()
    const fallbackFormatter = (cell) => (cell ? cell : "-");

    const columns = [
        {
            dataField: "user_id",
            text: "User ID",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "subscription_id",
            text: "Subscription ID",
            formatter: (cell) => {
                if (!cell) return "-";
                const handleCopy = () => {
                    navigator.clipboard.writeText(cell).then(() => {
                        setCopiedId(cell);
                        setTimeout(() => setCopiedId(null), 1500);
                    });
                };
                return (
                    <span className="d-flex align-items-center gap-2">
                        <span
                            title={cell}
                            style={{
                                maxWidth: '120px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                display: 'inline-block',
                                verticalAlign: 'middle'
                            }}
                        >
                            {cell}
                        </span>
                        <button
                            onClick={handleCopy}
                            title="Copy Subscription ID"
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '2px 4px',
                                color: copiedId === cell ? '#28a745' : '#6c757d',
                                transition: 'color 0.2s'
                            }}
                        >
                            {copiedId === cell ? <FaCheck size={12} /> : <FaCopy size={12} />}
                        </button>
                    </span>
                );
            },
            colStyle: "text-nowrap",
        },
        {
            dataField: "user_name",
            text: "Name",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "user_email",
            text: "Email",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "user_mobile",
            text: "Phone",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "countryname",
            text: "Country",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "subscription_device_type",
            text: "Signed-in Device",
            formatter: (cell) => (
                <span className="d-flex align-items-center gap-2">
                    {cell === 'web' ? <FaGlobe size={12} /> : <FaMobileAlt size={12} />}
                    {cell || "-"}
                </span>
            ),
            colStyle: "text-nowrap",
        },
        {
            dataField: "createdAt",
            text: "Date",
            formatter: (cell) => formatDate(cell),
            colStyle: "text-nowrap",
        },
        {
            dataField: "subscription_status",
            text: "Status",
            formatter: (cell, row) => {
                const status = row.subscriptions_ends_at && new Date(row.subscriptions_ends_at) > new Date() ? 'Subscribed' : 'Expired';
                return (
                    <span className={`status-badge ${status === 'Subscribed' ? 'subscribed' : 'unsubscribed'}`}>
                        {status}
                    </span>
                );
            },
            colStyle: "text-nowrap",
        },
        {
            dataField: "plans_name",
            text: "Package",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "subscription_price_paid",
            text: "Price",
            formatter: (cell, row) => `${row.subscription_currency || '$'} ${cell || '0.00'} `,
            colStyle: "text-nowrap",
        },
        {
            dataField: "subscription_starts_at",
            text: "Subscribed Date",
            formatter: (cell) => formatDateTimeText(cell),
            colStyle: "text-nowrap",
        },
        {
            dataField: "subscriptions_ends_at",
            text: "Next Billing Date",
            formatter: (cell) => formatDateTimeText(cell),
            colStyle: "text-nowrap",
        },
        {
            dataField: "PaymentGateway",
            text: "Paid With",
            formatter: (cell) => {
                if (!cell) return "-";
                return cell.charAt(0).toUpperCase() + cell.slice(1).toLowerCase();
            },
            colStyle: "text-nowrap",
        },

    ];

    const handleInput = (e) => {
        const { name, value } = e.target;
        setEditUser((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const fetchData = async () => {
        setLoading(true)
        try {
            const response = await fetchRequest({
                method: "GET",
                url: `${process.env.REACT_APP_Baseurl}/admin/Subscription-purchased-analytics`,
                params: {
                    limit, page,
                    filter_type: editUser?.filterType,
                    startDate: editUser?.startDate,
                    endDate: editUser?.endDate,
                    search: searchText,
                    platform: editUser?.platform,
                    country: editUser?.country,
                    status: editUser?.status
                }
            });
            const userData = response?.Subscription;
            setApiData(userData);
            setFilteredData(userData);
            setTotal(response?.pagination);
            setSubscriptionCounts({
                total: response?.total_subscriptions || 0,
                active: response?.active_subscriptions || 0,
                cancelled: response?.cancelled_subscriptions || 0
            });
            setChartData({
                categories: response?.monthly_revenue_months || [],
                series: [{ name: "SUBSCRIBER", data: response?.monthly_revenue_counts || [] }]
            });
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    const handleExportData = async (exportType, format) => {
        setLoading(true);
        try {
            const params = {
                filter_type: editUser?.filterType,
                startDate: editUser?.startDate,
                endDate: editUser?.endDate,
                search: searchText,
                platform: editUser?.platform,
                country: editUser?.country,
                status: editUser?.status
            };

            const response = await fetchRequest({
                method: "GET",
                url: `${process.env.REACT_APP_Baseurl}/admin/Subscription-purchased-analytics`,
                params: params
            });

            const allData = response?.Subscription || [];
            const fileName = exportType === 'all' ? 'SUBSCRIBER-ANALYTICS-ALL' : 'SUBSCRIBER-ANALYTICS-DATEWISE';

            if (format === 'pdf') {
                PDFGeneratorSubscriber(allData, fileName);
            } else if (format === 'xlsx') {
                XLSXGeneratorSubscriber(allData, fileName);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error exporting data:", error);
            setLoading(false);
        }
    };

    const [allExportData, setAllExportData] = useState([]);
    const csvLinkRef = useRef();

    const fetchAllForCSV = async (exportType) => {
        setLoading(true);
        try {
            const params = {
                filter_type: editUser?.filterType,
                startDate: editUser?.startDate,
                endDate: editUser?.endDate,
                search: searchText,
                platform: editUser?.platform,
                country: editUser?.country,
                status: editUser?.status
            };

            const response = await fetchRequest({
                method: "GET",
                url: `${process.env.REACT_APP_Baseurl}/admin/Subscription-purchased-analytics`,
                params: params
            });

            const allData = response?.Subscription || [];
            setAllExportData(allData.map((item) => ({
                ...item,
                subscription_starts_at: formatDateTimeText(item?.subscription_starts_at),
                subscriptions_ends_at: formatDateTimeText(item?.subscriptions_ends_at),
                createdAt: formatDateTimeText(item?.createdAt)
            })));
            setLoading(false);
            setTimeout(() => {
                if (csvLinkRef.current) {
                    csvLinkRef.current.link.click();
                }
            }, 500);
        } catch (error) {
            console.error("Error fetching all data for CSV:", error);
            setLoading(false);
        }
    };

    const fetchFilterTypeData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/filter-types`, { headers: userAccessToken });
            setDefaultData(prev => ({ ...prev, filterTypes: response?.data?.FilterTypes }));
        } catch (error) {
            console.error("Error fetching filter types:", error);
        }
    };

    const fetchDashboardData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/dashboard`, { headers: userAccessToken });
            const data = response.data.data;
            setTopVideosData(data);
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchFilterTypeData();
        fetchDashboardData();
    }, [withOutRefresh, page, limit, searchText]);

    useEffect(() => {
        if (topVideosData && editUser.topVideoFilter) {
            const selectedData = topVideosData[editUser.topVideoFilter] || [];
            // Group by title and count
            const grouped = selectedData.reduce((acc, item) => {
                if (!item.title) return acc;
                if (!acc[item.title]) {
                    acc[item.title] = { title: item.title, count: 0, country: item.countryname || 'Various' };
                }
                acc[item.title].count += 1;
                return acc;
            }, {});
            const sorted = Object.values(grouped).sort((a, b) => b.count - a.count).slice(0, 5);
            setTopVideos(sorted);
        }
    }, [topVideosData, editUser.topVideoFilter]);

    useEffect(() => {
        fetchData();
    }, [editUser.startDate, editUser.endDate, editUser.filterType, editUser.platform, editUser.country, editUser.status]);

    const handleReload = () => {
        setWithoutRefresh(!withOutRefresh);
        setEditUser({ startDate: "", endDate: "", filterType: "", platform: "All", country: "All", status: "All" });
    }

    const handleSort = (field) => {
        const sortedData = [...filteredData].sort((a, b) => a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0);
        setFilteredData(sortedData);
    };

    return (
        <div className="subscriber-analytics-container">
            <div className="d-flex align-items-center mb-4 flex-wrap gap-2">
                <h3 className="fw-bold mb-0 theme-text-color me-auto">Subscriber Analytics</h3>

                <AdminHeader
                    hideExport hideExportAll hideSearch
                    reduceData={filteredData}
                    originalData={apiData}
                    reloadAction={handleReload}
                    fileName={'SUBSCRIBER-ANALYTICS'}
                    customSubscriber reload loading={loading}
                />

                <CSVLink
                    headers={CSVColumnSubscriber}
                    data={allExportData}
                    filename="SUBSCRIBER-ANALYTICS-ALL.csv"
                    className="d-none"
                    ref={csvLinkRef}
                />
            </div>

            {/* Summary Cards */}
            <div className="row g-4 mb-5">
                {[
                    { title: "Total Subscriptions", count: subscriptionCounts.total, icon: <FaUsers />, class: "total" },
                    { title: "Active Subscriptions", count: subscriptionCounts.active, icon: <FaPlay />, class: "active" },
                    { title: "Cancelled Subscriptions", count: subscriptionCounts.cancelled, icon: <FaPause />, class: "cancelled" }
                ].map((stat, i) => (
                    <div key={i} className="col-md-4">
                        <div className="premium-card stat-card">
                            <div className={`stat-icon ${stat.class}`}>{stat.icon}</div>
                            <div>
                                <h2 className="fw-bold mb-0">{stat.count}</h2>
                                <p className="text-muted small mb-0">{stat.title}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row g-4 mb-5">
                {/* 2 & 3. Subscription Reports & Segment Filters */}
                <div className="col-lg-8">
                    <div className="premium-card h-100">
                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                            <h5 className="section-title mb-0"><FaChartLine /> Subscription Growth</h5>

                        </div>


                        {/* <div className="mb-4">
                            <p className="small text-muted mb-2">Segment Filters</p>
                            <div className="d-flex gap-2">
                                {["All", ...defaultData.platforms].map(p => (
                                    <span key={p}
                                        onClick={() => setEditUser(prev => ({ ...prev, platform: p }))}
                                        className={`segment-pill ${editUser.platform === p ? 'active' : ''}`}
                                    >{p}</span>
                                ))}
                                <select name="country" value={editUser.country} onChange={handleInput} className="ms-auto custom-select-premium py-1 h-auto">
                                    <option value="All">All Countries</option>
                                    {defaultData.countries.map(c => <option key={c} value={c}>{c}</option>)}
                                </select>
                            </div>
                        </div>  */}

                        <div className="chart-container">
                            <ApexAreaChart users={apiData} chartData={chartData} />
                        </div>
                    </div>
                </div>

                {/* 4 & 5. Status Analytics & Top Videos */}
                <div className="col-lg-4">
                    <div className="row g-4">
                        <div className="col-12">
                            <div className="premium-card">
                                <h5 className="section-title"><FaUsers /> Subscription Status</h5>
                                <div className="d-flex justify-content-center py-3">
                                    <div className="text-center px-4">
                                        <h3 className="fw-bold text-success">{subscriptionCounts.active}</h3>
                                        <p className="small text-muted">Subscribed</p>
                                    </div>
                                    <div className="vr"></div>
                                    <div className="text-center px-4">
                                        <h3 className="fw-bold text-danger">{subscriptionCounts.total - subscriptionCounts.active}</h3>
                                        <p className="small text-muted">Non-Subscribed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-12">
                            <div className="premium-card">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="section-title mb-0"><FaVideo /> Top Performing Videos</h5>
                                    <select
                                        name="topVideoFilter"
                                        value={editUser.topVideoFilter}
                                        onChange={handleInput}
                                        className="custom-select-premium py-0 h-auto"
                                        style={{ fontSize: '11px' }}
                                    >
                                        <option value="currentMonthData">This Month</option>
                                        <option value="lastMonthData">Last Month</option>
                                        <option value="lastWeekData">Last Week</option>
                                        <option value="todayData">Today</option>
                                    </select>
                                </div>
                                {topVideos.length > 0 ? topVideos.map((video, i) => (
                                    <div key={i} className="top-video-item">
                                        <div className="video-rank">{i + 1}</div>
                                        <div className="video-info">
                                            <h6 className="text-truncate" style={{ maxWidth: '200px' }}>{video.title}</h6>
                                            <p>{video.count} purchases • {video.country}</p>
                                        </div>
                                    </div>
                                )) : <p className="text-center text-muted small py-3">No data available for this period</p>}
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* 1. Subscribers Table */}
            <div className="premium-card">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="section-title mb-0">Subscriber List</h5>

                    <div className="position-relative" style={{ minWidth: '250px' }}>
                        <input
                            type='text'
                            placeholder="Search subscribers..."
                            className="form-control rounded-pill px-4 border-0 theme-bg-color-secondary"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>
                </div>
                <div className="d-flex  align-items-center justify-content-end mb-4">



                    <div className="d-flex gap-2 align-items-center flex-wrap">
                        <select name="filterType" value={editUser.filterType} onChange={handleInput} className="custom-select-premium" style={{ width: '180px' }}>
                            <option value="">Choose Duration</option>
                            {defaultData.filterTypes.map(t => <option key={t.filter_type} value={t.filter_type}>{t.name}</option>)}
                        </select>
                        <input type="date" name="startDate" value={editUser.startDate} onChange={handleInput} className="custom-date-premium" />
                        <input type="date" name="endDate" value={editUser.endDate} onChange={handleInput} className="custom-date-premium" />

                        <div className="dropdown">
                            <button className="btn btn-success dropdown-toggle d-flex align-items-center gap-2 hideArrow" type="button" id="exportAllDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="fw-bolder text-white" style={{ fontSize: '14px' }}>{(editUser.filterType || editUser.startDate || editUser.endDate) ? 'Export Custom' : 'Export All'}</span>
                                <img src={ExportIcon} className="exportIcon" alt="exportIcon" style={{ width: '13px' }} />
                            </button>
                            <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllDropdown">
                                <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchAllForCSV('all')}>CSV</li>
                                <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => handleExportData('all', 'pdf')}>PDF</li>
                                <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => handleExportData('all', 'xlsx')}>XLSX</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="bootstrapTable scroll-active pb-4">
                    <AdminTable
                        data={filteredData}
                        loading={loading}
                        options={{
                            pageStartIndex: 1,
                            paginationSize: 3,
                            sizePerPage: limit,
                        }}
                        handlePageChange={handlePageChange}
                        page={page}
                        pagination={total}
                        handleSizePerPageChange={handleSizePerPageChange}
                        columns={columns}
                        limit={limit}
                        onSort={handleSort}
                        viewType={formData?.view_type}
                        className="no-border-table table-premium"
                    />
                </div>
            </div>
        </div>
    );
};

export default SubscriberAnalytics;
